import { Http } from '@angular/http';
import { ApplicationUser } from './../../services/ApplicationUser';
import {Injectable} from "@angular/core";
import {LoginModel} from "./auth.model";

@Injectable()
export class AuthService {
    constructor(private http: Http) {}

    login(model: LoginModel) {
        return new Promise((resolve, reject) => {
            this.http.post('/login', model)
                .map(r => r.json())
                .subscribe((response) => {
                    const user = ApplicationUser.getInstance();
                    user.login(response.data);
                    resolve();
                }, (err) => {
                    reject(err);
                });
        });
    }

    restoreLogin(model: LoginModel) {
        return new Promise((resolve, reject) => {
            this.http.post('/login/restore', model)
                .map(r => r.json())
                .subscribe((response) => {
                    resolve();
                }, (err) => {
                    reject(err);
                });
        });
    }

    enterBy(token) {
        return new Promise((resolve, reject) => {
            this.http.get('/enter/by?Authorization=' + encodeURI(token))
                .map(r => r.json())
                .subscribe((response) => {
                    const user = ApplicationUser.getInstance();
                    user.login(response.data);
                    resolve();
                }, (err) => {
                    reject(err);
                });
        });
    }
}


// WEBPACK FOOTER //
// ./src/app/models/auth/auth.service.ts